module.exports = __webpack_public_path__ + "img/warning.1005700c.svg";